export const getAdditionalFeesOrderItems = fees => (fees == null ? void 0 : fees.map(fee => {
  var _fee$name, _fee$price$amount, _fee$price;
  return {
    id: fee.code,
    name: (_fee$name = fee.name) != null ? _fee$name : '',
    price: (_fee$price$amount = (_fee$price = fee.price) == null ? void 0 : _fee$price.amount) != null ? _fee$price$amount : '0',
    quantity: 1
  };
})) || [];
//# sourceMappingURL=getAdditionalFeesOrderItems.js.map